export const isFlightListingItem = (item) =>
  Boolean(item) && !item.ad && !item.crossSellAd && !item.isSponsoredAd

export const countFlightListingItems = (listings = []) => listings.filter(isFlightListingItem).length

const getFlightIndexes = (nodes = []) => {
  const indexes = []
  nodes.forEach((node, index) => {
    if (node?.isFlightCard) {
      indexes.push(index)
    }
  })
  return indexes
}

/**
 * Where to splice the phone banner for PKG_FLY_LISTINGS_MOVE_PHONE_BANNER VARIANT.
 * Returns a list index, or null to skip this section.
 */
export const getPhoneSalesBannerInsertIndex = ({
  listingsNodes = [],
  listType,
  isRecommendedSearch,
  otherFlightsItineraryCount = 0,
}) => {
  const flightIndexes = getFlightIndexes(listingsNodes)

  if (isRecommendedSearch) {
    if (listType === 'listings') {
      if (flightIndexes.length === 0) return null
      return flightIndexes[0] + 1
    }

    if (listType === 'recommendedListings' && otherFlightsItineraryCount === 0) {
      return listingsNodes.length
    }

    return null
  }

  if (listType !== 'listings' || flightIndexes.length === 0) {
    return null
  }

  const eighthFlightIndex = flightIndexes[7]
  const lastFlightIndex = flightIndexes.at(-1)
  return (eighthFlightIndex ?? lastFlightIndex) + 1
}
